import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { css } from "styled-components";

savedOrderDetailsActionButtonsStyles.deleteButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
    buttonType: "outline",
    variant: "secondary",
}

savedOrderDetailsActionButtonsStyles.addToListButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
    buttonType: "outline",
    variant: "secondary",
}

savedOrderDetailsActionButtonsStyles.continueShoppingButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}

savedOrderDetailsActionButtonsStyles.middleHiddenContainer = {
    above: "md",
    below: "md",
    css:css`
        display: flex;
    `,
}

savedOrderDetailsActionButtonsStyles.middleOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            display: inline;
            margin-left: 20px;
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF;
            }
        `,
    },
}

savedOrderDetailsActionButtonsStyles.narrowOverflowMenu = {
    cssOverrides:{
        wrapper: css`
            span {
                color: #FFFFFF !important;
            }
            ul {
                background: #FFFFFF;
            }
        `,
    }
}